import { MtProjectUserGroup } from "server/models"
import { GET, POST, DELETE } from "client/store/utils"
import { ASC } from "const"
import {
    ProjectGroupList,
    SortProjectGroups,
    UserList,
    SortUsers,
} from "client/store"
import {
    ProjectUserGroupList,
    ProjectGroupUserList,
} from "./types"

// load groups for all users in single project
export const LoadAllProjectUserGroups = (accountId: number, projectId: number, groupList?: ProjectGroupList) => (
    GET(`/mtProjectUserGroup/all/${accountId}/${projectId}`)
    .then((rows: MtProjectUserGroup[]) => {
        const userGroupList: ProjectUserGroupList = {}
        rows.forEach((row) => {
            const groupIds: number[] = userGroupList[row.userId] ? userGroupList[row.userId].slice() : []
            groupIds.push(row.groupId)
            userGroupList[row.userId] = groupIds
        })

        if (groupList) { // sort groups - used in table popover
            const sortedGroupIds: number[] = SortProjectGroups(Object.values(groupList), "order", ASC, {})
            const sortedUserGroupList: ProjectUserGroupList = {}
            const userIds = Object.keys(userGroupList).map(Number)
            userIds.forEach((userId) => {
                const assignedGroupIds = userGroupList[userId]
                sortedUserGroupList[userId] = sortedGroupIds.filter((groupId) => assignedGroupIds.includes(groupId))
            })

            return sortedUserGroupList
        }
        return userGroupList
    })
)

// load users in all groups in single project
export const LoadAllProjectGroupUsers = (accountId: number, projectId: number, userList?: UserList) => (
    GET(`/mtProjectUserGroup/all/${accountId}/${projectId}`)
    .then((rows: MtProjectUserGroup[]) => {
        const groupUserList: ProjectGroupUserList = {}
        rows.forEach((row) => {
            const groupIds: number[] = groupUserList[row.groupId] ? groupUserList[row.groupId].slice() : []
            groupIds.push(row.userId)
            groupUserList[row.groupId] = groupIds
        })

        if (userList) { // sort users - used in table popover
            const sortedUserIds: number[] = SortUsers(Object.values(userList), "firstName", ASC, {})
            const sortedGroupUserList: ProjectGroupUserList = {}
            const groupIds = Object.keys(groupUserList).map(Number)
            groupIds.forEach((groupId) => {
                const assignedUserIds = groupUserList[groupId]
                sortedGroupUserList[groupId] = sortedUserIds.filter((userId) => assignedUserIds.includes(userId))
            })

            return sortedGroupUserList
        }
        return groupUserList
    })
)

export const LoadProjectUserGroups = (
    userId: number,
    accountId: number,
    projectId: number,
    groupList?: ProjectGroupList,
) => (
    GET(`/mtProjectUserGroup/userGroups/${userId}/${accountId}/${projectId}`)
    .then((rows: MtProjectUserGroup[]) => {
        const groupIds: number[] = []
        rows.forEach((row) => {
            groupIds.push(row.groupId)
        })

        if (groupList) { // sort groups - used in table popover
            const sortedGroupIds: number[] = SortProjectGroups(Object.values(groupList), "order", ASC, {})
            return sortedGroupIds.filter((groupId) => groupIds.includes(groupId))
        }
        return groupIds
    })
)

export const LoadProjectGroupUsers = (
    groupId: number,
    accountId: number,
    projectId: number,
    userList?: UserList,
) => (
    GET(`/mtProjectUserGroup/groupUsers/${groupId}/${accountId}/${projectId}`)
    .then((rows: MtProjectUserGroup[]) => {
        const userIds: number[] = []
        rows.forEach((row) => {
            userIds.push(row.userId)
        })

        if (userList) { // sort users - used in table popover
            const sortedUserIds: number[] = SortUsers(Object.values(userList), "firstName", ASC, {})
            return sortedUserIds.filter((userId) => userIds.includes(userId))
        }
        return userIds
    })
)

export const AddProjectUserGroup = (data: MtProjectUserGroup[]) => (
    POST(
        "/mtProjectUserGroup/add",
        JSON.stringify(data),
    )
)

export const DeleteProjectUserGroup = (
    userId: number,
    groupId: number,
    projectId: number,
    accountId: number,
) => (
    DELETE(`/mtProjectUserGroup/delete/${userId}/${groupId}/${projectId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)
